import jsPDF from "jspdf";

import { drawHeader } from "../../../component/WGRHeader";
import { drawFooter } from "../../../component/WGRFooter";
import { drawFinancialTable } from "./faPDFTable";
import { handlePdf, PDF_ACTION } from "../../../../../utils/pdfHelper";

export default function generateWGRPDF(
  title,
  rows,
  grandTotal,  
  month,
  year
) {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });




 // console.log(rows);




  const displayRows =
    rows && rows.length > 0
      ? rows
      : [
          {
            PMONTH: month,
            PYEAR: year,
            Labour: 0,
            store: 0,
            freight: 0,
            proforma: 0,
            revenue: 0,
            POH: 0,
            DRR: 0,
            ReturnStore: 0,
            Electrical: 0,
            BulkOrder: 0,
          },
        ];

  //drawHeader(doc, title, month, year);

  drawFinancialTable(doc, displayRows);

  drawFooter(doc, month, year, title);

  handlePdf(doc, PDF_ACTION.VIEW);
}